import { Helmet } from 'react-helmet-async';

const SITE = 'https://aktechsolutions.de';
const SITE_NAME = 'AK TechSolutions';
const DEFAULT_IMG = `${SITE}/assets/logo_long.jpg`;

interface Props {
  title: string;
  description: string;
  path?: string;
  noIndex?: boolean;
}

const PageMeta = ({ title, description, path = '', noIndex = false }: Props) => {
  const url = `${SITE}${path}`;
  const fullTitle = `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_IMG} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMG} />
    </Helmet>
  );
};

export default PageMeta;
